import EmailFooterV2 from '../components/FooterV2';

interface EmailProps {
  userName: string
  examName: string
  voucherCode: string
  examProvider: string
  examDuration: string
  validUntil: string
  examLanguage: string
  examFormat: string
  schedulingInstructions: string
  schedulingLink: string
  companyName: string
  supportEmail?: string
  supportPhone?: string
}

export default function ExamVoucherDeliveryEmail({
  userName = "João Silva",
  examName = "Microsoft Azure Fundamentals (AZ-900)",
  voucherCode = "AZ900-2025-ABC123",
  examProvider = "Microsoft",
  examDuration = "60 minutos",
  validUntil = "31 de dezembro de 2025",
  examLanguage = "Português (Brasil)",
  examFormat = "Online Proctored",
  schedulingInstructions = "Acesse o site da Pulsefy e agende seu exame usando o código do voucher",
  schedulingLink = "https://trivium.com.br/agendamento",
  companyName = "Empresa XYZ Ltda",
  supportEmail = "suporte@trivium.com.br",
  supportPhone = "(11) 3181-5940",
}: EmailProps) {
  return (
     <div style={{ margin: 0, padding: 0, fontFamily: "Arial, sans-serif", backgroundColor: "#f8f9fa" }}>
      {/* Responsive CSS Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @media only screen and (max-width: 600px) {
            .email-container { width: 100% !important; max-width: 100% !important; border-radius: 0 !important; }
            .body-content { padding: 24px 20px !important; }
            .header { padding: 16px !important; }
            .logo { width: 100px !important; }
            .title { font-size: 20px !important; margin: 12px 0 4px !important; }
            .subtitle { font-size: 14px !important; margin: 0 0 20px !important; }
            .badge { font-size: 12px !important; padding: 6px 12px !important; }
            .card { padding: 12px !important; margin-bottom: 6px !important; }
            .card-label { font-size: 11px !important; }
            .card-value { font-size: 14px !important; }
            .section-title { font-size: 16px !important; margin: 20px 0 8px !important; }
             .section-title svg { width: 25px !important; height: 25px !important; }
            .info-box { padding: 16px !important; }
            .info-box h3 { font-size: 15px !important; }
            .info-box p { font-size: 13px !important; }
            .info-list { font-size: 13px !important; }
            .btn { display: block !important; width: 100% !important; text-align: center !important; margin-bottom: 8px !important; }
            .btn-primary { padding: 14px 16px !important; font-size: 15px !important; }
            .list, .warning-list { font-size: 13px !important; padding-left: 16px !important; }
            .contact-box { padding: 16px !important; }
            .contact-title { font-size: 15px !important; }
            .contact-info { font-size: 13px !important; }
            .footer { padding: 20px 16px !important; }
            .footer-logo { width: 70px !important; }
            .social-icons { justify-content: center !important; gap: 20px !important; }
            .social-icon { width: 24px !important; height: 24px !important; }
            .voucher-code { font-size: 18px !important; padding: 12px !important; }
          }
          @media only screen and (max-width: 480px) {
            .body-content { padding: 20px 16px !important; }
            .title { font-size: 18px !important; }
            .subtitle { font-size: 13px !important; }
            .card { padding: 10px !important; }
            .card-label { font-size: 10px !important; }
            .card-value { font-size: 13px !important; }
            .section-title { font-size: 15px !important; }
             .section-title svg { width: 22px !important; height: 22px !important; }
            .info-box { padding: 14px !important; }
            .btn-primary { padding: 12px 14px !important; font-size: 14px !important; }
            .social-icons { gap: 16px !important; }
            .social-icon { width: 22px !important; height: 22px !important; }
            .voucher-code { font-size: 16px !important; padding: 10px !important; }
          }
        `
      }} />
      
       <table
         width="100%"
         border={0}
         cellSpacing={0}
         cellPadding={0}
         style={{ backgroundColor: "#f8f9fa", padding: "40px 0" }}
       >
        <tbody>
          <tr>
            <td align="center">
              <table
                className="email-container"
                width={600}
                border={0}
                cellSpacing={0}
                cellPadding={0}
                style={{ 
                  backgroundColor: "#ffffff", 
                  borderRadius: "12px", 
                  overflow: "hidden",
                  maxWidth: "600px",
                  margin: "0 auto"
                }}
              >
                <tbody>
                  {/* Header */}
                  <tr>
                    <td 
                      className="header"
                      align="center" 
                      style={{ 
                        backgroundColor: "#1F1746", 
                        padding: "20px",
                        textAlign: "center"
                      }}
                    >
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <img
                          className="logo"
                          src="https://asset.brandfetch.io/idNdb_MPJ2/idFGj2lq6u.png?c=1dxbfHSJFAPEGdCLU4o5B"
                          alt="Logo Trivium"
                          width={120}
                          style={{ 
                            display: "block", 
                            width: "120px", 
                            height: "auto",
                            margin: "0 auto"
                          }}
                        />
                      </div>
                    </td>
                  </tr>

                  {/* Body */}
                  <tr>
                    <td 
                      className="body-content"
                      style={{ 
                        padding: "36px 30px", 
                        color: "#333333"
                      }}
                    >
                      {/* Badge + Title */}
                      <div style={{ textAlign: "center" }}>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#dbeafe",
                            color: "#1e40af",
                            display: "inline-block",
                            padding: "8px 16px",
                            borderRadius: "999px",
                            fontSize: "13px",
                            fontWeight: 700,
                            marginBottom: "16px"
                          }}
                        >
                          🎫 Voucher de Exame
                        </span>
                        <h1 
                          className="title"
                          style={{ 
                            fontSize: "24px", 
                            margin: "16px 0 6px", 
                            color: "#111111",
                            lineHeight: "1.3"
                          }}
                        >
                          Olá, {userName} 👋
                        </h1>
                        <p 
                          className="subtitle"
                          style={{ 
                            fontSize: "16px", 
                            margin: "0 0 24px", 
                            color: "#555555", 
                            lineHeight: "1.6"
                          }}
                        >
                          Seu voucher para o exame de certificação
                          <br />
                          <strong>{examName}</strong> está pronto!
                        </p>
                      </div>

                      {/* Voucher Code Highlight */}
                      <div style={{ textAlign: "center", margin: "24px 0" }}>
                        <div
                          style={{
                            backgroundColor: "#3b65f5",
                            borderRadius: "12px",
                            padding: "24px",
                            color: "#ffffff",
                            textAlign: "center"
                          }}
                        >
                          <div style={{ fontSize: "14px", marginBottom: "8px", opacity: "0.9" }}>
                            Seu código do voucher:
                          </div>
                          <div
                            className="voucher-code"
                            style={{
                              fontSize: "24px",
                              fontWeight: "bold",
                              fontFamily: "monospace",
                              backgroundColor: "rgba(255,255,255,0.2)",
                              padding: "16px",
                              borderRadius: "8px",
                              letterSpacing: "2px",
                              border: "2px dashed rgba(255,255,255,0.3)"
                            }}
                          >
                            {voucherCode}
                          </div>
                          <div style={{ fontSize: "12px", marginTop: "8px", opacity: "0.8" }}>
                            Guarde este código com segurança
                          </div>
                        </div>
                      </div>

                      {/* Informações do Exame */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                         <svg 
                           width="29" 
                           height="29" 
                           viewBox="0 0 17.46 11.64" 
                           style={{ display: "inline-block", verticalAlign: "middle" }}
                           xmlns="http://www.w3.org/2000/svg"
                         >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Informações do Exame
                      </h2>
                       <div
                         className="info-box"
                         style={{
                           backgroundColor: "#f8f9fa",
                           borderRadius: "10px",
                           padding: "20px",
                           marginBottom: "16px"
                         }}
                       >
                        <h3 style={{ margin: "0 0 4px", fontSize: "16px", color: "#1F1746" }}>{examName}</h3>
                        <p style={{ margin: "0 0 14px", fontSize: "14px", color: "#6b7280" }}>Exame de Certificação {examProvider}</p>
                        <table 
                          width="100%" 
                          cellPadding={0} 
                          cellSpacing={0} 
                          className="info-list"
                          style={{ fontSize: "14px", color: "#111" }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🎫 <strong>Código do Voucher:</strong> {voucherCode}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                📅 <strong>Válido até:</strong> {validUntil}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Como Agendar */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                         <svg 
                           width="29" 
                           height="29" 
                           viewBox="0 0 17.46 11.64" 
                           style={{ display: "inline-block", verticalAlign: "middle" }}
                           xmlns="http://www.w3.org/2000/svg"
                         >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Como Agendar seu Exame
                      </h2>
                       <div
                         className="info-box"
                         style={{
                           backgroundColor: "#f8f9fa",
                           borderRadius: "10px",
                           padding: "20px",
                           marginBottom: "16px"
                         }}
                       >
                        <p style={{ margin: "0 0 16px", fontSize: "14px", color: "#111" }}>
                          {schedulingInstructions}
                        </p>
                        <div style={{ textAlign: "center" }}>
                          <a
                            href={schedulingLink}
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#3b65f5",
                              color: "#ffffff",
                              textDecoration: "none",
                              padding: "12px 18px",
                              borderRadius: "8px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              display: "inline-block",
                              cursor: "pointer",
                              transition: "background-color 0.3s ease",
                              maxWidth: "100%",
                              boxSizing: "border-box"
                            }}
                          >
                            Agendar Exame Agora
                          </a>
                        </div>
                      </div>

                      {/* Próximos passos */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                         <svg 
                           width="29" 
                           height="29" 
                           viewBox="0 0 17.46 11.64" 
                           style={{ display: "inline-block", verticalAlign: "middle" }}
                           xmlns="http://www.w3.org/2000/svg"
                         >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Próximos Passos
                      </h2>
                       <div
                         className="info-box"
                         style={{
                           backgroundColor: "#f8f9fa",
                           borderRadius: "10px",
                           padding: "20px",
                           marginBottom: "16px"
                         }}
                       >
                        <ul
                          className="list"
                          style={{
                            fontSize: "14px",
                            color: "#4b5563",
                            lineHeight: "1.8",
                            paddingLeft: "20px",
                            margin: 0
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>✅ Acesse o portal de agendamento da Pulsefy</li>
                          <li style={{ marginBottom: "8px" }}>✅ Use o código do voucher para agendar seu exame</li>
                          <li style={{ marginBottom: "8px" }}>✅ Escolha a data e horário que melhor se adequam à sua agenda</li>
                          <li style={{ marginBottom: "8px" }}>✅ Prepare-se estudando o material recomendado</li>
                        </ul>
                      </div>

                      {/* Informações importantes */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "18px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                         <svg 
                           width="29" 
                           height="29" 
                           viewBox="0 0 17.46 11.64" 
                           style={{ display: "inline-block", verticalAlign: "middle" }}
                           xmlns="http://www.w3.org/2000/svg"
                         >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Informações Importantes
                      </h2>
                       <div
                         className="warning-box"
                         style={{
                           background: "#fffbeb",
                           borderRadius: "10px",
                           padding: "18px"
                         }}
                       >
                        <ul
                          className="warning-list"
                          style={{
                            fontSize: "14px",
                            color: "#374151",
                            lineHeight: "1.9",
                            paddingLeft: "20px",
                            margin: 0
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>⏰ O voucher é válido até {validUntil} - não perca o prazo!</li>
                          <li style={{ marginBottom: "8px" }}>💻 Para exames online, teste sua conexão e equipamentos previamente</li>
                          <li style={{ marginBottom: "8px" }}>📚 Estude o material oficial recomendado pelo {examProvider}</li>
                          <li style={{ marginBottom: "8px" }}>🔒 Mantenha o código do voucher em local seguro</li>
                          <li style={{ marginBottom: "8px" }}>✉️ Em caso de dúvidas, entre em contato conosco</li>
                        </ul>
                      </div>

                      {/* Contato de suporte */}
                       <div
                         className="contact-box"
                         style={{
                           backgroundColor: "#f8f9fa",
                           borderRadius: "10px",
                           padding: "18px",
                           margin: "20px 0",
                           textAlign: "center"
                         }}
                       >
                        <h2 
                          className="contact-title"
                          style={{ 
                            fontSize: "16px", 
                            color: "#111", 
                            margin: "0 0 10px"
                          }}
                        >
                          🤝 Precisa de ajuda? Entre em contato conosco:
                        </h2>
                        <p 
                          className="contact-info"
                          style={{ 
                            margin: 0, 
                            fontSize: "14px", 
                            color: "#374151", 
                            lineHeight: "1.6"
                          }}
                        >
                          ✉️ {supportEmail}
                          <br />📱 {supportPhone}
                        </p>
                      </div>
                    </td>
                  </tr>

                  {/* Footer */}
                  <tr>
                    <EmailFooterV2 variant="clean" showContactInfo={true} />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
